export { default } from './MobileNavigationPlaceholder';
